import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

const BoundsSchema = z.object({
  x: z.number().nullable(),
  y: z.number().nullable(),
  width: z.number().nullable(),
  height: z.number().nullable(),
});

export type Bounds = z.infer<typeof BoundsSchema>;

const AnnotationToPointOfInterestSchema = z.object({
  id: z.string().uuid(),
  pointOfInterest: z.string().uuid(),
  annotation: z.string().uuid(),
  order: z.number().optional().default(0),
});

export type AnnotationToPointOfInterest = z.infer<typeof AnnotationToPointOfInterestSchema>;

export const PointOfInterestSchema = BaseSchema.extend({
  images: z.array(z.string().uuid()).optional(),
  slide: z.string().uuid(),
  bounds: BoundsSchema,
  note: z.string().nullable().default(null),
  annotationToPointOfInterest: z.array(AnnotationToPointOfInterestSchema).default([]),
  order: z.number(),
  name: z.string().max(255),
});

export type PointOfInterest = z.infer<typeof PointOfInterestSchema>;

export const PointOfInterestEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: PointOfInterestSchema,
});

export type PointOfInterestEntityQueryResult = z.infer<typeof PointOfInterestEntityQueryResultSchema>;
